import { Locales } from '@/types/locale';

export class Format {
  static price = (price: number, locale: Locales) => {
    return new Intl.NumberFormat(locale.short, {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 2,
    }).format(price / 100);
  };

  static priceAlreadyDecimal = (price: number) => {
    return new Intl.NumberFormat('fr', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 2,
    }).format(price);
  };

  static date = (
    date = new Date(),
    locale: Locales,
    options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    }
  ): string => {
    return new Intl.DateTimeFormat(locale.full, {
      ...options,
      timeZone: 'Europe/Paris',
    }).format(new Date(date.toISOString()));
  };

  static address = ({
    city,
    country,
    postcode,
    address,
    format = 'medium',
  }: {
    city: string;
    country: string;
    postcode: string;
    address: string;
    format: 'medium' | 'full';
  }) => {
    if (!address || !city) return '';
    return format === 'medium'
      ? `${address}, ${postcode} ${city}`
      : `${address}, ${postcode} ${city}, ${country}`;
  };

  static leftPad(str: string, size: number, char: string = ' '): string {
    const diff = size - str.length;
    if (diff <= 0) return str;
    const padding = char.repeat(diff);
    return padding + str;
  }

  static creditCardLast4(str: string) {
    const filledCreditCard = Format.leftPad(str, 16, '•');
    return filledCreditCard.match(new RegExp(`.{1,4}`, 'g'))!.join(' ');
  }
}
